export enum Role {
  User = '',
  HRManager = 'HR Manager',
  HRTeam = 'HR Team',
  Medical = 'Medical',
  Finance = 'Finance Team',
  Safety = 'STCW',
  Admin = 'Product',
  CrewAdminManager = 'Crew Admin Manager',
}
